import React from "react";

import { t } from "../../i18n";
// `secondaryLabel` + `onSecondary` (optional) add one more, outlined, choice next to "OK" (e.g. "Print").
const ConfirmationModal = ({
  isOpen,
  message,
  onConfirm,
  onCancel,
  secondaryLabel,
  onSecondary,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-panel max-w-[400px] p-6" role="dialog" aria-modal="true">
        {/* Modal Message */}
        <p className="text-lg font-semibold mb-6 text-slate-800 text-center">{message}</p>

        {/* Action Button */}
        <div className="flex justify-center gap-3">
          <button
            onClick={onConfirm}
            className="px-6 py-2 bg-brand-600 text-white rounded-lg font-medium shadow-sm hover:bg-brand-700"
          >
            {t("موافق")}
          </button>
          {secondaryLabel && onSecondary && (
            <button
              onClick={onSecondary}
              className="px-6 py-2 bg-card text-brand-700 border border-brand-300 rounded-lg font-medium hover:bg-brand-50"
            >
              {secondaryLabel}
            </button>
          )}
          {onCancel && (
            <button
              onClick={onCancel}
              className="px-6 py-2 bg-card text-slate-700 border border-slate-300 rounded-lg font-medium hover:bg-slate-100"
            >
              {t("إلغاء")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
